// Offer-card image carousel; extra slides injected only on activation.
export const OfferCardCarousel = (extra: string[] = [], more = 0, url = '') => ({
    activated: false,
    index: 0,
    extra,
    more,
    url,

    get isMobile(): boolean {
        return document.body.classList.contains('is-mobile');
    },
    get slideCount(): number {
        return this.extra.length + 1;
    },
    get atStart(): boolean {
        return this.index <= 0;
    },
    get atEnd(): boolean {
        return this.index >= this.slideCount - 1;
    },

    activateOnView() {
        if (this.isMobile) this.activate();
    },
    activateOnHover() {
        if (!this.isMobile) this.activate();
    },
    activate() {
        if (this.activated || !this.extra.length) return;
        this.activated = true;
    },

    onScroll() {
        const track = this.$refs.track as HTMLElement;
        const width = track.clientWidth;
        if (width) this.index = Math.round(track.scrollLeft / width);
    },
    scroll(direction: 'next' | 'prev') {
        const track = this.$refs.track as HTMLElement;
        track.scrollBy({
            top: 0,
            left: direction === 'next' ? track.clientWidth : -track.clientWidth,
            behavior: 'smooth',
        });
    },

    prevBtn: {
        [':class']() { return { 'is-disabled': this.atStart }; },
        ['@click.prevent.stop']() { this.scroll('prev'); },
    },
    nextBtn: {
        [':class']() { return { 'is-disabled': this.atEnd }; },
        ['@click.prevent.stop']() { this.scroll('next'); },
    },
})
